import React from "react";
import { Helmet } from "react-helmet";

const Seo = () => {
  const title =
    "PlayGG - Level Up Your Game: Discover Nearby Gaming Cafes, Play Tournaments & Win Rewards!";
  const description =
    "Experience the thrill of competitive and casual gaming with PlayGG. We are India's leading online gaming platform, offering a vast selection of games, tournaments, and features for gamers of all skill levels.";
  const keywords = [
    "PlayGG",
    "PlayGG gaming",
    "PlayGG games",
    "PlayGG India",
    "find nearby gaming cafe",
    "gaming cafe near me",
    "play tournaments near me",
    "mini games platform",
    "earn rewards gaming",
    "PlayGG cafe",
    "PlayGG gaming cafe",
    "PlayGG tournaments",
    "online gaming tournaments",
    "local gaming tournaments",
    "gaming cafe finder",
    "nearby gaming cafes",
    "play mini games online",
    "gaming rewards platform",
    "PlayGG rewards",
    "gaming tournaments India",
    "gaming cafe India",
    "best gaming cafes near me",
    "PlayGG esports",
    "esports tournaments near me",
    "play games and earn rewards",
    "find esports tournaments",
    "PlayGG game rewards",
    "host gaming tournaments",
    "gaming cafes nearby",
    "play games at PlayGG",
    "gaming rewards app",
    "PlayGG esports platform",
    "local gaming spots",
    "find gaming spots near me",
    "gaming tournaments platform",
    "PlayGG esports cafe",
    "PlayGG community",
    "join gaming tournaments",
    "best mini games app",
    "PlayGG gaming events",
    "discover gaming cafes",
    "PlayGG app India",
    "competitive gaming near me",
    "PlayGG gaming rewards",
    "earn rewards at PlayGG",
    "gaming near me India",
    "play games nearby",
    "PlayGG tournaments India",
    "gaming cafes in India",
    "gaming community app",
    "PlayGG mini games",
    "PlayGG gaming platform",
    "PlayGG gaming rewards",
    "PlayGG tournaments near me",
    "PlayGG mini games",
    "PlayGG nearby gaming cafes",
    "PlayGG play and earn",
    "PlayGG local tournaments",
    "PlayGG esports gaming",
    "PlayGG gaming events",
    "PlayGG India tournaments",
    "PlayGG gaming cafe finder",
    "PlayGG host tournaments",
    "PlayGG earn rewards",
    "PlayGG join tournaments",
    "PlayGG find gaming cafes",
    "PlayGG esports community",
    "PlayGG gaming hub",
    "PlayGG India gaming",
    "PlayGG best gaming cafes",
    "PlayGG gaming rewards app",
    "PlayGG mini games online",
    "PlayGG cafe finder",
    "PlayGG tournament finder",
    "PlayGG game community",
    "PlayGG esports tournaments",
    "PlayGG competitive gaming",
    "PlayGG esports India",
    "PlayGG gaming centers",
    "PlayGG online rewards",
    "PlayGG app for gamers",
    "PlayGG gaming locations",
    "PlayGG tournaments India",
    "PlayGG gaming cafes nearby",
    "PlayGG discover games",
    "PlayGG mini games rewards",
    "PlayGG gaming enthusiasts",
    "PlayGG esports rewards",
    "PlayGG local gaming spots",
    "PlayGG nearby gaming spots",
    "PlayGG gaming lounge",
    "PlayGG game finder",
    "PlayGG host events",
    "PlayGG India esports",
    "PlayGG fun games",
    "PlayGG nearby tournaments",
    "PlayGG gaming community India",
    "PlayGG premium rewards",
    "PlayGG join gaming cafes",
    "PlayGG India platform",
    "PlayGG find gaming hubs",
    "online gaming platform",
    "play games online",
    "free online games",
    "multiplayer games online",
    "gaming community",
    "online gaming community India",
    "best online games",
    "discover new games",
    "online gaming tournaments",
    "esports tournaments",
    "play tournaments online",
    "register for tournaments",
    "free entry tournaments",
    "win tournaments",
    "gaming competitions",
    "esports competitions",
    "join gaming tournaments",
    "competitive gaming",
    "earn rewards",
    "win prizes",
    "gaming rewards",
    "in-game rewards",
    "rewards program",
    "win real prizes",
    "free rewards",
    "exclusive rewards",
    "redeem rewards",
    "reward points",
    "gaming cafes near me",
    "find gaming cafes",
    "book gaming cafes",
    "gaming cafe bookings",
    "gaming lounges",
    "gaming arenas",
    "local gaming cafes",
    "best gaming cafes",
    "affordable gaming cafes",
    "gaming cafe finder",
    "play mini games online",
    "casual games online",
    "quick games",
    "fun mini games",
    "arcade games online",
    "puzzle games online",
    "skill games",
    "brain games",
    "mobile games",
    "PlayGG gaming zones",
    "PlayGG virtual tournaments",
    "PlayGG esports hub",
    "PlayGG play online",
    "PlayGG nearby gamers",
    "PlayGG gaming communities",
    "PlayGG rewards and prizes",
    "PlayGG tournament tracker",
    "PlayGG gaming cafe discounts",
    "PlayGG find players",
    "PlayGG esports India",
    "PlayGG fun tournaments",
    "PlayGG competitive gaming",
    "PlayGG gaming leaderboard",
    "PlayGG skill-based games",
    "PlayGG nearby challenges",
    "PlayGG gaming buddies",
    "PlayGG join events",
    "PlayGG gaming leagues",
    "PlayGG app download",
    "PlayGG nearby play zones",
    "PlayGG challenge games",
    "PlayGG gaming cafe rewards",
    "PlayGG find gaming cafes",
    "PlayGG explore esports",
    "PlayGG discover tournaments",
    "PlayGG competitive events",
    "PlayGG skill tournaments",
    "PlayGG top cafes",
    "PlayGG game lounge",
    "PlayGG esports app",
    "PlayGG gamer rewards",
    "PlayGG casual gaming",
    "PlayGG local meetups",
    "PlayGG pro gaming",
    "PlayGG gaming news",
    "PlayGG trending tournaments",
    "PlayGG app India",
    "PlayGG local events",
    "PlayGG find gaming spots",
    "PlayGG arcade gaming",
    "PlayGG exclusive rewards",
    "PlayGG earn game credits",
    "PlayGG premium cafes",
    "PlayGG join gaming sessions",
    "PlayGG skill games online",
    "PlayGG fun challenges",
    "PlayGG regional tournaments",
    "PlayGG global gaming",
    "PlayGG new gaming cafes",
    "PlayGG online challenges",
    "play games for free",
    "coupons",
    "india best gaming tournament platform",
    "Online gaming platform India",
    "Best gaming platform India",
    "Gaming app for tournaments India",
    "Multiplayer gaming platform India",
    "Esports gaming platform India",
    "Competitive gaming platform India",
    "Virtual gaming platform India",
    "Play games win rewards India",
    "Online gaming tournaments India",
    "Esports tournament platform India",
    "Register for gaming tournaments India",
    "Play tournaments India",
    "Competitive esports tournaments India",
    "Join multiplayer tournaments India",
    "Free entry gaming tournaments India",
    "Gaming tournament events India",
    "Professional esports tournaments India",
    "Best esports tournaments India",
    "Book gaming cafes online India",
    "Gaming cafe booking platform India",
    "Reserve gaming cafe spot India",
    "Book a gaming arena India",
    "Find local gaming cafes India",
    "Gaming cafe near me India",
    "Gaming lounge bookings India",
    "Book a gaming desk online India",
    "Affordable gaming cafe bookings India",
    "Best gaming cafes for LAN parties India",
    "gaming",
    "video games",
    "video game player",
    "gamer",
    "gaming enthusiast",
    "casual gamer",
    "hardcore gamer",
    "competitive gamer",
    "esports player",
    "gaming lifestyle",
    "Steam",
    "Epic Games",
    "PlayStation",
    "Xbox",
    "Nintendo",
    "Discord",
    "Twitch",
    "YouTube Gaming",
    "Facebook Gaming",
    "Stadia",
    "RPG",
    "FPS",
    "MOBA",
    "MMORPG",
    "Strategy",
    "Puzzle",
    "Adventure",
    "Action",
    "Racing",
    "Sports",
    "gaming PC",
    "gaming laptop",
    "gaming console",
    "gaming headset",
    "gaming mouse",
    "gaming keyboard",
    "gaming monitor",
    "gaming chair",
    "controller",
    "streaming equipment",
    "gaming community",
    "esports community",
    "gaming culture",
    "gaming influencers",
    "gaming podcasts",
    "gaming blogs",
    "gaming events",
    "gaming conventions",
    "cosplay",
    "gaming memes",
  ];

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords.join(", ")} />
      <meta name="author" content="PlayGG INDIA" />

      {/* Facebook Open Graph */}
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta
        property="og:image"
        content="https://www.facebook.com/getweplay?mibextid=ZbWKwL"
      />
      {/* Replace with your image URL */}
      <meta property="og:url" content="../src/assets/logo.png" />
      {/* Replace with your website URL */}
      {/* Twitter Meta Tags */}
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta
        name="twitter:image"
        content="https://x.com/GetWePlay?t=vJGTAWJ6nTG6--mqCWaZ5Q&s=09"
      />
      {/* Replace with your image URL */}
      <meta name="twitter:card" content="summary_large_image" />
      {/* YouTube Meta Tags */}
      <meta property="og:site_name" content="PlayGG" />
      {/* Replace with PlayGG */}
      <meta property="og:type" content="website" />
      <meta
        property="og:video"
        content="https://youtube.com/@getweplay?si=J3maRdmbyOpfzVv3"
      />
      {/* Replace with your YouTube video URL */}
      <meta property="og:video:type" content="application/x-shockwave-flash" />
      <meta property="og:video:width" content="1280" />
      <meta property="og:video:height" content="720" />
      {/* Instagram Meta Tags */}
      <meta property="instagram:card" content="summary_large_image" />
      <meta property="instagram:title" content={title} />
      <meta property="instagram:description" content={description} />
      <meta
        property="instagram:image"
        content="https://www.instagram.com/getwePlayGG?igsh=dmFncXlkYmJpYnBq"
      />
    </Helmet>
  );
};

export default Seo;
